module.exports = __webpack_public_path__ + "static/9th-8fdbe0cac134dcdd43d1f908e013bc98.png";